import { useGetPayments } from "@/hooks/payments";

export function useGetBalances(reservationId: string) {
  const q = useGetPayments(reservationId);
  return { ...q, data: q.data?.filter((p) => !p.isDeposit) };
}
